import React from "react";

import rightArrow from "assets/images/homepage/setting/ManageUser/rightArrow.svg";
import rightArrowDark from "assets/images/homepage/setting/ManageUser/rightArrowDark.svg";

import useTheme from "hooks/observer";

import "./changePlan.scss";
// import Plan from "containers/Plan/index";

const ChangePlan = ({ setChangePlan }) => {
  // Function to handle going back to settings
  const handleBack = () => {
    // Reset the activeTab to 0 (General tab)
    sessionStorage.removeItem("activeTab");
    // Close the Change Plan component
    setChangePlan(false);
  };
  const theme = useTheme();
  // const plans = [
  //   {
  //     name: "Free",
  //     price: 0,
  //     storage: "10 GB/User",
  //     teamstorage: "1 TB/Team",
  //     features: [
  //       "Email hosting for multiple domains",
  //       "Folder sharing",
  //       "10 GB file upload limit"
  //     ],
  //     buttonText: "Current plan",
  //     currentPlan: "Current Plan",
  //     disabled: true,
  //     star: false
  //   },
  //   {
  //     name: "Basic",
  //     price: 400,
  //     storage: "50 GB/User",
  //     teamstorage: "1 TB/Team",
  //     features: [
  //       "Email hosting for multiple domains",
  //       "Folder sharing",
  //       "10 GB file upload limit"
  //     ],
  //     buttonText: "Get Started Now",
  //     disabled: false,
  //     star: true
  //   },
  //   {
  //     name: "Pro",
  //     price: 700,
  //     storage: "1 TB/User",
  //     teamstorage: "100 GB/Team",
  //     features: [
  //       "Email hosting for multiple domains",
  //       "Folder sharing",
  //       "10 GB file upload limit"
  //     ],
  //     buttonText: "Get Started Now",
  //     disabled: false,
  //     star: true
  //   }
  // ];
  return (
    <div className="container changePlanContainer">
      <div className="breadcrumb">
        <p className="settings" onClick={handleBack}>
          Settings
        </p>
        <img
          src={theme == "light" ? rightArrow : rightArrowDark}
          alt="rightArrow"
        />
        <p className="changePlan">Change Plan</p>
      </div>
      <div className="planContainerBox">
        {/* <Plan
          freeTrialText={false}
          paymentSummary={true}
          plans={plans}
          features={true}
        /> */}
      </div>
    </div>
  );
};

export default ChangePlan;
